import React from 'react';
import styled from 'styled-components';
import { LuTriangleAlert } from 'react-icons/lu';
import { Modal, ModalTitle, ModalBody, ModalFooter } from './Modal';

const WarningIcon = styled.div`
  width: 56px;
  height: 56px;
  border-radius: 50%;
  background: #fef3c7;
  color: #d97706;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 16px;
`;

const Message = styled.p`
  margin: 0;
  white-space: pre-wrap;
`;

const ConfirmButton = styled.button`
  background: linear-gradient(135deg, #1e3a8a 0%, rgb(19, 85, 154) 100%);
  color: #ffffff;
  border: none;
  border-radius: 12px;
  padding: 12px 24px;
  font-size: 15px;
  font-weight: 600;
  font-family: 'Montserrat', sans-serif;
  cursor: pointer;
  transition: opacity 0.2s ease, transform 0.2s ease;

  &:hover {
    opacity: 0.92;
    transform: translateY(-1px);
  }
`;

const HomologationModal = ({ isOpen, onClose, title, message }) => (
  <Modal isOpen={isOpen} onClose={onClose}>
    <WarningIcon>
      <LuTriangleAlert size={28} />
    </WarningIcon>
    <ModalTitle>{title}</ModalTitle>
    <ModalBody>
      <Message>{message}</Message>
    </ModalBody>
    <ModalFooter>
      <ConfirmButton type="button" onClick={onClose}>
        Entendi
      </ConfirmButton>
    </ModalFooter>
  </Modal>
);

export default HomologationModal;
